import { render } from "./FansStoreDetail.vue?vue&type=template&id=488f4b64&scoped=true"
import script from "./FansStoreDetail.vue?vue&type=script&lang=js"
export * from "./FansStoreDetail.vue?vue&type=script&lang=js"

import "./FansStoreDetail.vue?vue&type=style&index=0&id=488f4b64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-488f4b64"]])

export default __exports__